module.exports = __webpack_public_path__ + "img/C05TechPVPCivilEngineering_ua.ff36440f.webp";